import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MasterDetailModule } from '@sdbn/common';
import { AutomationRulesComponent } from './component/automation-rules.component';
import { ApplicationClientCommonModule, CommonTranslationModule } from '@sdbn/common';
import { TableSelectionDialogModule } from '@sdbn/tmc-common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableSelectionDialogModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    MasterDetailModule,
    MatSelectModule,
    MatFormFieldModule,
    DragDropModule,
    MatInputModule,
    MatCheckboxModule,
    MatRadioModule
  ],
  declarations: [
    AutomationRulesComponent
  ]
})
export class AutomationRulesModule { }

